import React, { FC, ReactElement } from 'react'
import { Box, List, Heading, Text } from 'grommet'
import { Link } from 'gatsby'
import './recognition.scss'
import { useLayoutConfig, AwardsListItemI } from '../../custom-hooks/useLayoutConfig'

interface RecognitionPropsI {
  list: AwardsListItemI[]
}

const RecognitionList: FC<RecognitionPropsI> = ({ list }: RecognitionPropsI) => (
  <List data={list} className="recognition-list-container" border="vertical">
    {(item: AwardsListItemI): ReactElement<typeof Box> => (
      <Box margin={{ bottom: 'small' }}>
        <Heading level={3} size="small">
          {item.title}
        </Heading>
        <Text size="medium">{item.year}</Text>
        <Text size="medium">- {item.giver}</Text>
      </Box>
    )}
  </List>
)

const Recognition: FC = () => {
  const layoutConfig = useLayoutConfig()

  return (
    <Box margin={{ vertical: 'large', horizontal: 'medium' }}>
      <Box align="center">
        <Heading level={2} size="medium">
          Awards & Recognitions
        </Heading>
        <Text>For which we thank our guests and our people.</Text>
      </Box>
      <Box align="end">
        <Link to={'/awards'}>
          <Text>View All Awards</Text>
        </Link>
      </Box>
      <Box margin={{ top: 'large' }}>
        <RecognitionList list={layoutConfig.awards} />
      </Box>
    </Box>
  )
}

export default Recognition
